// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c11p5{display:grid}
._4cvr1h6o{align-items:center}
._4t3i1pna{height:420px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/assets-modal/modal/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY;AACvB,WAAW,kBAAkB;AAC7B,WAAW,YAAY","sourcesContent":["._1e0c11p5{display:grid}\n._4cvr1h6o{align-items:center}\n._4t3i1pna{height:420px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
